<script>
import {
  osArchitectureOptions,
  pcSystemTypeOptions,
  booleanOptions,
  deviceStatusOptions,
  driveTypeOptions,
  pointingTypeOptions,
  connectionStatusOptions,
  activationStatusOptions,
  userAccountTypeOptions,
  memoryTypeOptions,
  mobileDeviceTypeOptions,
  usbComponentStatusOptions,
} from '../../helpers/option-map'
export default {
  name: 'PropertyComponentProvider',
  provide() {
    const propertyComponentContext = {
      name: 'propertyComponentContext',
    }
    // add osArchitecture
    Object.defineProperty(propertyComponentContext, 'osArchitectureOptions', {
      enumerable: true,
      get: () => {
        return osArchitectureOptions()
      },
    })
    // add pcSystemTypeOptions
    Object.defineProperty(propertyComponentContext, 'pcSystemTypeOptions', {
      enumerable: true,
      get: () => {
        return pcSystemTypeOptions()
      },
    })
    // add deviceStatusOptions
    Object.defineProperty(propertyComponentContext, 'deviceStatusOptions', {
      enumerable: true,
      get: () => {
        return deviceStatusOptions()
      },
    })
    // add driveTypeOptions
    Object.defineProperty(propertyComponentContext, 'driveTypeOptions', {
      enumerable: true,
      get: () => {
        return driveTypeOptions()
      },
    })
    // add pointingTypeOptions
    Object.defineProperty(propertyComponentContext, 'pointingTypeOptions', {
      enumerable: true,
      get: () => {
        return pointingTypeOptions()
      },
    })
    // add connectionStatusOptions
    Object.defineProperty(propertyComponentContext, 'connectionStatusOptions', {
      enumerable: true,
      get: () => {
        return connectionStatusOptions()
      },
    })
    // add activationStatusOptions
    Object.defineProperty(propertyComponentContext, 'activationStatusOptions', {
      enumerable: true,
      get: () => {
        return activationStatusOptions()
      },
    })
    // add userAccountTypeOptions
    Object.defineProperty(propertyComponentContext, 'userAccountTypeOptions', {
      enumerable: true,
      get: () => {
        return userAccountTypeOptions()
      },
    })
    // add memoryTypeOptions
    Object.defineProperty(propertyComponentContext, 'memoryTypeOptions', {
      enumerable: true,
      get: () => {
        return memoryTypeOptions()
      },
    })
    // add boolean otions
    Object.defineProperty(propertyComponentContext, 'booleanOptions', {
      enumerable: true,
      get: () => {
        return booleanOptions()
      },
    })
    // add mobileDeviceTypeOptions
    Object.defineProperty(propertyComponentContext, 'mobileDeviceTypeOptions', {
      enumerable: true,
      get: () => {
        return mobileDeviceTypeOptions()
      },
    })
    // add usbComponentStatusOptions
    Object.defineProperty(
      propertyComponentContext,
      'usbComponentStatusOptions',
      {
        enumerable: true,
        get: () => {
          return usbComponentStatusOptions()
        },
      }
    )
    return { propertyComponentContext }
  },
  render() {
    return this.$scopedSlots.default()
  },
}
</script>
